
  export const style = {
    api: {
      apiProduction: "https://cheirinbao.prd.appnoz.com.br/",
      newApiProduction: "null",
      samlUrl: null,
      nameProfile: "Cheirin Bao",
      hostHeader: "cheirinbao",
    },

    icons: {
      loginIcon: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_cheirinbao.png",
      secondaryLogonLogo: "null",
      menuIcon: localStorage.getItem("menuIcon") || "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_cheirinbao.png",
      browserLogo: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/favicon_client_cheirinbao.png",
    },

    shareAttributes: {
      shareImage: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_cheirinbao.png",
      shareTitle: "Noz - Plataforma de comunicação",
      shareDescription: "O NOZ é um aplicativo de comunicação personalizado, onde é possível criar conteúdos de acordo com a segmentação do seu público de maneira gamificada.",
    },

    names: {
      nameApp: localStorage.getItem("nameApp") || "Cheirin Bao",
      nameScore: "Cheirin Coins",
      nameStore: "Loja",
      nameAcademy: localStorage.getItem("nameAcademy") || "Cursos",
      nameTeam: localStorage.getItem("nameTeam") || "Time",
      nameCalendar: localStorage.getItem("nameCalendar") || "Calendário",
      nameTools: localStorage.getItem("nameTools") || "Ferramentas",
    },

    colors: {
      primaryColor: localStorage.getItem("primaryColor") || "#4D2612",
      secondaryColor: localStorage.getItem("secondaryColor") || "#4D2612",
      tertiaryColor: "",
    },

    variables: {
      gamificationEnabled: true,
      child_profiles: [],
      hasPrivacyPolicies: false,
      externalUse: false,
      customClient: true,
      customMenuItem: true,
      autoRegister: false,
      recaptchaVersion: "V2",
      showBirthday: "true"
    },
  };
